
import React from 'react'
import { Box, CircularProgress } from '@mui/material'

function Loader() {
  return (
    <>
    
    <Box sx={{
        position:'fixed',
        height:'100%',
        width:'100%',
        backgroundColor:'#00000099',
        zIndex:1300,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    }}
    >
        <Box>
            <CircularProgress/>
        </Box>
    </Box>
    
    </>
  )
}

export default Loader